import DownloadUtils from '../../DownloadUtils';
import { getItemDownloadDirectory } from './getItemDownloadDirectory';
import URL from './URL';
import { registerDownloadTaskEventListeners, } from './registerDownloadTaskEventListeners';
import { removeDownloads } from './removeDownloads';
const getPathFromUrl = (item, uuid, url, filename) => {
    const dir = getItemDownloadDirectory(item, uuid);
    const parsed = new URL(url);
    const ext = parsed.pathname.split('.').at(-1);
    const file = `${filename}.${ext}`;
    return {
        absolute: `${dir.absolute}/${file}`,
        relative: `${dir.relative}/${file}`,
    };
};
export class DownloadCancelledError extends Error {
    constructor() {
        super('download job cancelled');
    }
}
export const upsertDownloads = async ({ uuid, items = [], client, }) => {
    const dirOps = items.map((item) => {
        const { absolute } = getItemDownloadDirectory(item, uuid);
        return DownloadUtils.mkdir(absolute);
    });
    await Promise.all(dirOps);
    const ops = [];
    items.forEach((item) => {
        const stream = item?.asset?.stream;
        const cover = item?.cover?.src;
        const metadata = {
            uuid,
            item,
        };
        if (!stream)
            throw new Error('Error attemting to download due to no valid download stream available.');
        const assetDownloadPath = getPathFromUrl(item, uuid, stream, 'asset');
        const assetMetadata = {
            ...metadata,
            destination: assetDownloadPath.relative,
        };
        const assetJobId = `${item.id}:asset`;
        const assetTask = DownloadUtils
            .download({
            id: assetJobId,
            url: stream,
            destination: assetDownloadPath.absolute,
            metadata: assetMetadata
        });
        const assetOp = registerDownloadTaskEventListeners({
            task: assetTask,
            client,
        });
        ops.push(assetOp);
        let coverDownloadPath;
        if (cover) {
            coverDownloadPath = getPathFromUrl(item, uuid, cover, 'cover');
            const coverMetadata = {
                ...metadata,
                destination: coverDownloadPath.relative,
            };
            const coverJobId = `${item.id}:cover`;
            const coverTask = DownloadUtils
                .download({
                id: coverJobId,
                url: cover,
                destination: coverDownloadPath.absolute,
                metadata: coverMetadata,
            });
            const coverOp = registerDownloadTaskEventListeners({
                task: coverTask,
                client,
            });
            ops.push(coverOp);
        }
    });
    return {
        promise: Promise.all(ops),
        cancel: () => {
            removeDownloads({ uuid, items, client });
        },
    };
};
//# sourceMappingURL=upsertDownloads.js.map